(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-categorized/assets/javascripts/handlebar-helpers.js') >= 0) return;  svs.modules.push('/widgets/oddset-categorized/assets/javascripts/handlebar-helpers.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

function registerHelpers(hbs) {
  hbs.registerHelper('iconNameOddsetCategorized', function (sport) {
    switch (sport.toLowerCase()) {
      case 'fotboll':
        return 'soccer';

      case 'ishockey':
        return 'hockey';

      case 'tennis':
        return 'tennis';

      case 'innebandy':
        return 'floorball';

      case 'basket':
        return 'basketball';

      case 'handboll':
        return 'handball';

      default:
    }
  });
}
 })(window);